import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: { [key: string]: any } = {};

const profile = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updateProfileData(state, action: PayloadAction<object>) {
      return { ...state, ...(action.payload ?? {}) };
    }
  }
});

const { actions, reducer } = profile;
export const { updateProfileData } = actions;
export default reducer;
